import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {Ttm} from '../../classes/ttm';
import {HttpClient} from '@angular/common/http';
import {Entity} from '../../classes/entity';
import {Subscription} from 'rxjs';
import {TtmTypes} from '../../classes/ttm-types.enum';

@Component({
    selector: '[app-svg-as-img]',
    templateUrl: './svg-as-img.component.html',
    styleUrl: './svg-as-img.component.scss'
})
export class SvgAsImgComponent implements OnInit, OnDestroy {
    TtmTypes = TtmTypes;

    @Input() svg: string;
    @Input() ttm: Ttm;
    blob: any;

    viewedEntity?: Entity;
    updateImageSubscription: Subscription;

    constructor(private cdref: ChangeDetectorRef, private http: HttpClient) {
    }


    ngOnInit() {
        if (this.svg) {
            let blob = new Blob([this.svg], {type: 'image/svg+xml'});
            this.blob = URL.createObjectURL(blob);
        } else if (this.ttm) {
            this.ttm.entities.forEach(entity => {
                if (!this.blob) {
                    this.viewedEntity = entity;
                    if (entity.plain_image) {
                        if (!entity.updateImage) {
                            entity.updateImage = new EventEmitter();
                        }
                        this.updateImageSubscription = entity.updateImage.subscribe(() => {
                            this.viewedEntity = this.ttm.entities.find(e => !!e.id);
                            if (this.viewedEntity.plain_image) {
                                let blob = new Blob([this.viewedEntity.plain_image.svg], {type: 'image/svg+xml'});
                                this.blob = URL.createObjectURL(blob);
                                this.cdref.detectChanges();
                            }
                        });
                        entity.updateImage.emit();
                    }
                }
            });
        }
    }

    ngOnDestroy() {
        delete this.blob;
        this.updateImageSubscription?.unsubscribe();
    }

}
